import type { Sprachschluessel } from './de'

/**
 * Begriffe des Hauses (R148, R157).
 *
 * **Der Kunde darf jede Beschriftung durch einen eigenen Begriff ersetzen** —
 * „Buchungskreis" statt „Gesellschaft" —, **ohne dass sich die Bedeutung ändert.**
 * Deshalb liegt das hier als eigene Schicht über den Sprachdateien und nicht
 * als Änderung an ihnen: Wer `de.ts` bearbeitet, verliert seine Begriffe beim
 * nächsten Update; wer hier schreibt, nicht.
 *
 * **Was diese Schicht ausdrücklich nicht kann**, und das ist der Unterschied
 * zwischen einer Beschriftung und einer zweiten Definition:
 *
 * - Sie legt keinen elften Bereich an und schafft keinen ab (R149, R157).
 * - Sie verschiebt keinen Unterpunkt in einen anderen Bereich.
 * - Sie deutet kein Zustandssymbol um — die fünf Zustände sind Bedeutungen,
 *   keine Beschriftungen (7.1, Grenzfälle).
 *
 * Ein Schlüssel, den es nicht gibt, wird stillschweigend nicht angewendet: Der
 * Typ `Partial<Record<Sprachschluessel, string>>` fängt Tippfehler bereits
 * beim Übersetzen ab.
 *
 * Im Auslieferungszustand ist die Schicht leer. Sie zu füllen ist Einrichtung
 * beim Kunden, nicht Programmierung — die Pflege am Bildschirm gehört unter
 * *Betrieb → Sprachen und Begriffe des Hauses* und ist noch nicht gebaut.
 */
export type Hausbegriffe = Partial<Record<Sprachschluessel, string>>

export const beschriftungen: Record<string, Hausbegriffe> = {
  de: {
    // Beispiel, absichtlich auskommentiert — der Auslieferungszustand ist leer:
    // 'bereich.stammdaten.einheiten': 'Buchungskreise',
  },
  en: {},
}
